import React, { useState } from 'react'
import { Button, Col, Space, Form, Popover } from 'antd'
import { successNotification, carsUrl, postRequest } from '../../config'
import SelectInput from 'components/Forms/SelectInput'
import BasicInput from '../../components/Forms/BasicInput'
import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'

const ProductImageUpdate = props => {
  const currentImage = props.currentImage
  const [payload, setPayload] = useState({
    active: currentImage.active,
    mainImage: currentImage.mainImage,
    isShowcaseImage: currentImage.isShowcaseImage,
    isVideo: currentImage.isVideo,
    videoId: currentImage.videoId
  })
  const [image, setImage] = useState('')
  const [serverErrors, setServerErrors] = useState({})
  const [loading, setLoading] = useState(false)

  const handleSelect = stateName => value => {
    setPayload({
      ...payload,
      [stateName]: value
    })
  }

  const handleImageChange = event => {
    setImage(event.target.files[0]) // Capture the file
  }

  const handleInputChange = stateName => event => {
    setPayload({ ...payload, [stateName]: event.target.value })
  }

  const handleSubmit = async event => {
    event.preventDefault()
    setLoading(true)

    // Prepare FormData
    const formData = new FormData()
    formData.append('image', image ? image : '')
    formData.append('is_showcase_image', payload.isShowcaseImage)
    formData.append('active', payload.active)
    formData.append('image_id', currentImage.id)
    formData.append('is_video', payload.isVideo)
    formData.append('video_id', payload.videoId)

    const response = await postRequest(
      `${carsUrl}/update-image`,
      formData,
      'image',
      setLoading,
      false
    )
    if (response.success) {
      props.handleCancel(response.data)
      successNotification('Image Updated')
    } else {
      if (response.error.response) {
        if (response.error.response) {
          setServerErrors(response.error.response.data)
        }
      }
    }
  }

  return (
    <div className="container">
      <div className="row">
        <div className="col-md-12">
          <Form className="p-2rem" layout="vertical">
            <div className="row">
              <div className="col-md-5">
                <SelectInput
                  placeholder="select"
                  label="Should this be used for showcase?"
                  name="isShowcaseImage"
                  value={payload.isShowcaseImage}
                  onChange={handleSelect('isShowcaseImage')}
                  optionList={[
                    { label: 'Yes', value: true },
                    { label: 'No', value: false }
                  ]}
                  required
                />
                {serverErrors.isShowcaseImage &&
                  serverErrors.isShowcaseImage.map((err, i) => (
                    <div className="text-danger" key={i}>
                      {err}
                    </div>
                  ))}
              </div>
              <div className="col-md-5">
                <SelectInput
                  placeholder="select"
                  label="Is this a video file"
                  name="isVideo"
                  value={payload.isVideo}
                  onChange={handleSelect('isVideo')}
                  optionList={[
                    { label: 'Yes', value: true },
                    { label: 'No', value: false }
                  ]}
                  required
                />
                {serverErrors.isVideo &&
                  serverErrors.isVideo.map((err, i) => (
                    <div className="text-danger" key={i}>
                      {err}
                    </div>
                  ))}
              </div>

              <div className="col-md-5">
                <SelectInput
                  placeholder="select"
                  label="Is Active"
                  name="active"
                  value={payload.active}
                  onChange={handleSelect('active')}
                  optionList={[
                    { label: 'Yes', value: true },
                    { label: 'No', value: false }
                  ]}
                  required
                />
                {serverErrors.active &&
                  serverErrors.active.map((err, i) => (
                    <div className="text-danger" key={i}>
                      {err}
                    </div>
                  ))}
              </div>

              {payload.isVideo ? (
                <div className="col-md-5">
                  <BasicInput
                    label={'Video URL'}
                    value={payload.videoId}
                    name={'videoId'}
                    placeholder="Video ID"
                    handleChange={handleInputChange('videoId')}
                    required={true}
                  />
                  <iframe
                    width="350"
                    height="200"
                    src={`https://www.youtube.com/embed/${payload.videoId}`}
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                  {serverErrors.videoId &&
                    serverErrors.videoId.map((err, i) => (
                      <div className="text-danger" key={i}>
                        {err}
                      </div>
                    ))}
                </div>
              ) : (
                <div
                  className="col-md-5"
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center'
                  }}
                >
                  <input
                    type="file"
                    accept="image/*"
                    onChange={handleImageChange}
                    required
                  />
                  <Popover
                    content={
                      <div>
                        <img
                          src={currentImage.image}
                          height={200}
                          width={200}
                          alt="product thumbnail"
                        />
                      </div>
                    }
                    title={'Car image'}
                    trigger="hover"
                  >
                    <img
                      src={currentImage.image}
                      height={80}
                      width={80}
                      alt="product thumbnail"
                    />
                  </Popover>
                  {serverErrors.image &&
                    serverErrors.image.map((err, i) => (
                      <div className="text-danger" key={i}>
                        {err}
                      </div>
                    ))}
                </div>
              )}

              {serverErrors.nonFieldErrors &&
                serverErrors.nonFieldErrors.map((err, i) => (
                  <div className="text-danger" key={i}>
                    {err}
                  </div>
                ))}

              <Col md={24}>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'flex-end',
                    marginBottom: '20px'
                  }}
                >
                  <Space>
                    <Button
                      type="primary"
                      onClick={handleSubmit}
                      loading={loading}
                    >
                      Submit
                    </Button>
                  </Space>
                </div>
              </Col>
            </div>
          </Form>
        </div>
      </div>
    </div>
  )
}

ProductImageUpdate.propTypes = {
  currentImage: PropTypes.object,
  handleCancel: PropTypes.func
}

export default withRouter(ProductImageUpdate)
